type ClickHandler<T = Element> = (e?: React.MouseEvent<T>) => void;

export const nonBubblingClickHandler = <T = Element>(h: ClickHandler<T>) => (event: React.MouseEvent<T>) => {
	event.stopPropagation();
	h(event);
};

export const nonBubbling = nonBubblingClickHandler;